var _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDividerPrimaryGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 369,
    height: 374,
    viewBox: "0 0 369 374",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.32227e-06 337.75L0 368L1.00002 368L1.00001 337.16L-1.32227e-06 337.75Z",
    fill: "url(#paint0_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00002 336.504L1.00002 318.092C0.542695 318.68 0.220126 319.271 -7.27371e-07 319.864L-4.69796e-07 325.756C0.308361 327.538 0.586274 329.326 -2.35964e-07 331.106L-2.57876e-09 336.445C0.0401595 336.448 0.0804657 336.45 0.120889 336.453C0.411604 336.471 0.708353 336.491 1.00002 336.504Z",
    fill: "url(#paint1_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 317.309C0.369517 317.274 0.722463 317.263 1.00002 317.302L1.00002 314.399L-1.14824e-07 314.682L-2.5232e-08 316.732C0.0889711 316.803 0.0985974 316.883 -1.45867e-08 316.975L0 317.309Z",
    fill: "url(#paint2_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.34562e-09 313.805C0.32789 313.812 0.662986 313.841 1.00002 313.904L1.00002 304.916C0.673858 304.913 0.337629 304.917 -3.91735e-07 304.943L-4.34562e-09 313.805Z",
    fill: "url(#paint3_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.86174e-08 303.929C0.220306 304.213 0.519354 304.455 1.00002 304.584L1.00002 300.105C0.953849 300.162 0.908412 300.219 0.862527 300.278C0.634364 300.567 0.395119 300.871 -1.49724e-07 301.158L-2.86174e-08 303.929Z",
    fill: "url(#paint4_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 285.494L0.865711 285.318C0.912999 285.34 0.957709 285.363 1.00002 285.385L1.00002 280.87C0.67947 280.994 0.341704 281.044 -1.9463e-07 281.041L-1.66635e-07 281.681C0.605 281.944 0.961805 282.287 0.843974 282.887C0.607866 283.089 0.313497 283.217 -9.58408e-08 283.301L0 285.494Z",
    fill: "url(#paint5_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.05441e-08 279.882C0.347802 279.978 0.693613 280.06 1.00002 280.123L1.00002 279.183C0.668336 279.221 0.322314 279.237 -3.93807e-08 279.222L-1.05441e-08 279.882Z",
    fill: "url(#paint6_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 277.643L1.00002 277.54L1.00002 267.231C0.753885 268.285 0.393882 269.333 -3.17775e-07 270.373L0 277.643Z",
    fill: "url(#paint7_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.1033e-09 258.75C0.309608 258.791 0.642498 258.83 1.00002 258.867L1.00002 246.822C0.990174 246.832 0.9803 246.842 0.970396 246.852C0.654447 247.166 0.30766 247.51 -4.80502e-07 247.874L-3.32613e-07 251.257C0.0668777 251.309 0.138033 251.36 0.213629 251.411C0.149515 251.406 0.0775482 251.401 -3.266e-07 251.395L-5.1033e-09 258.75Z",
    fill: "url(#paint8_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.66468e-08 238.56C0.251479 238.793 0.59535 238.992 1.00002 239.17L1.00002 234.371C0.757964 234.377 0.496237 234.379 0.213629 234.378L0.691823 237.11L-9.22701e-08 237.059L-2.66468e-08 238.56Z",
    fill: "url(#paint9_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.9145e-08 225.526C0.348476 225.769 0.667307 226.082 1.00002 226.421L1.00002 225.325C0.652828 225.409 0.325567 225.451 -4.19244e-08 225.462L-3.9145e-08 225.526Z",
    fill: "url(#paint10_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.2768e-08 224.91C0.255975 225.013 0.585346 225.11 1.00002 225.202L1.00002 222.561C0.979533 222.575 0.959014 222.588 0.938477 222.601C0.612651 222.813 0.28168 223.027 -8.57182e-08 223.241L-1.2768e-08 224.91Z",
    fill: "url(#paint11_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.05292e-10 220.625C0.344093 220.603 0.678765 220.603 1.00002 220.637L1.00002 213.162C0.65516 213.235 0.319574 213.307 -3.17302e-07 213.378L-2.45279e-07 215.025C0.455546 215.138 0.802028 215.312 0.952652 215.582C0.653129 215.622 0.332184 215.643 -2.17807e-07 215.654L-5.05292e-10 220.625Z",
    fill: "url(#paint12_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.67172e-09 191.913C0.324743 191.945 0.658742 191.972 1.00002 191.997L1.00002 186.15C0.655572 186.206 0.328718 186.249 -2.50854e-07 186.258L-9.2287e-08 189.886C0.134822 189.925 0.278328 189.964 0.43099 190.004C0.28078 190.021 0.137351 190.031 -8.56504e-08 190.038L-3.67172e-09 191.913Z",
    fill: "url(#paint13_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.05664e-08 161.307C0.402299 161.414 0.718664 161.578 1.00002 161.777L1.00002 161.002C0.742411 161.063 0.414217 161.122 -2.62433e-08 161.177L-2.05664e-08 161.307Z",
    fill: "url(#paint14_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 158.472C0.325845 158.445 0.66303 158.412 1.00002 158.375L1.00002 153.876C0.893208 154.163 0.587178 154.443 -1.64261e-07 154.715L-1.55939e-07 154.905C0.698819 155.298 0.507379 155.601 -1.12819e-07 155.891L-5.95258e-08 157.111C0.174426 157.328 0.403309 157.556 0.691823 157.784L-2.7843e-08 157.835L0 158.472Z",
    fill: "url(#paint15_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.24353e-08 152.169C0.472783 152.576 0.870322 152.977 1.00002 153.368L1.00002 147.14C0.449391 147.739 -0.0045792 148.366 0.0832146 148.996C0.0545369 148.993 0.0268045 148.989 -1.91598e-07 148.985L-5.24353e-08 152.169Z",
    fill: "url(#paint16_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 144.143L1.00002 144.118L1.00001 115.105C0.65085 115.177 0.318463 115.227 -1.26364e-06 115.235L-8.68549e-07 124.273C0.71063 125.325 1.2812 126.409 -7.26371e-07 127.526L0 144.143Z",
    fill: "url(#paint17_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 110.778C0.305186 110.7 0.624637 110.64 0.952652 110.603C0.968527 110.606 0.984315 110.609 1.00002 110.612L1.00002 107.779C0.582364 107.886 0.258785 107.991 -1.17283e-07 108.095L0 110.778Z",
    fill: "url(#paint18_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.47599e-09 107.468C0.184556 107.599 0.492144 107.674 1.00002 107.66L1.00002 104.946C0.912597 104.763 0.905152 104.58 1.00002 104.396L1.00002 104.196C0.564894 104.26 0.240872 104.314 -1.44355e-07 104.359L-8.47599e-09 107.468Z",
    fill: "url(#paint19_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.28404e-08 97.7508L0.387517 98.2733C0.778765 97.8471 0.713556 97.3127 0.409254 96.3601C0.61415 96.3859 0.810689 96.4148 1.00002 96.446L1.00002 96.1401C0.903246 96.1986 0.807556 96.2684 0.713559 96.352C0.240821 95.9555 0.107973 95.6079 -1.31314e-07 95.2692L-8.55841e-08 96.3154C0.131794 96.3289 0.259655 96.3439 0.387517 96.3601C0.229494 96.5177 0.104565 96.5971 -7.20414e-08 96.6252L-2.28404e-08 97.7508Z",
    fill: "url(#paint20_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 59.2834L1.00002 59.2784L1.00001 18.1777C0.674432 17.98 0.338558 17.7966 -1.82106e-06 17.6224L0 59.2834Z",
    fill: "url(#paint21_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.20036e-09 10.9749C0.335847 10.9911 0.670106 11.0177 1.00002 11.0481L1.00002 3.11741C0.652128 2.97676 0.31655 2.7864 -3.69636e-07 2.5918L-3.20036e-09 10.9749Z",
    fill: "url(#paint22_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00024 99.0722L0.257324 99.0251L1.00024 99.2124L1.00024 99.0722Z",
    fill: "url(#paint23_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00019 100.568C0.79044 100.602 0.586075 100.636 0.387695 100.671L0.461292 100.673C0.642112 100.678 0.820997 100.683 1.00019 100.693L1.00019 100.568Z",
    fill: "url(#paint24_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00012 168.348C0.871451 168.315 0.739814 168.28 0.60498 168.243C0.743194 168.303 0.874777 168.362 1.00012 168.419L1.00012 168.348Z",
    fill: "url(#paint25_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.99997 183.464C0.797592 183.666 0.572616 183.864 0.322266 184.056C0.567085 184.034 0.792591 184.016 0.99997 184.001L0.99997 183.464Z",
    fill: "url(#paint26_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 185.384C0.959698 185.449 0.955714 185.511 0.999999 185.567L0.999999 185.384Z",
    fill: "url(#paint27_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999824 240.867C0.28363 241.874 0.205771 242.455 0.999824 243.088L0.999824 240.867Z",
    fill: "url(#paint28_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999969 289.596C0.861491 290.372 0.906411 291.175 0.946811 291.899C1.01186 293.063 1.0652 294.018 0.322266 294.306C0.570818 294.417 0.796087 294.528 0.99997 294.639L0.999969 289.596Z",
    fill: "url(#paint29_linear_22_257)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_22_257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367 337.75L367 368L368 368L368 337.16L367 337.75Z",
    fill: "url(#paint30_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368 336.504L368 318.092C367.543 318.68 367.22 319.271 367 319.864L367 325.756C367.308 327.538 367.586 329.326 367 331.106L367 336.445C367.04 336.448 367.08 336.45 367.121 336.453C367.412 336.471 367.708 336.491 368 336.504Z",
    fill: "url(#paint31_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 317.309C367.37 317.274 367.722 317.263 368 317.302L368 314.399L367 314.682L367 316.732C367.089 316.803 367.099 316.883 367 316.975L367 317.309Z",
    fill: "url(#paint32_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 313.805C367.328 313.812 367.663 313.841 368 313.904L368 304.916C367.674 304.913 367.338 304.917 367 304.943L367 313.805Z",
    fill: "url(#paint33_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 303.929C367.22 304.213 367.519 304.455 368 304.584L368 300.105C367.954 300.162 367.908 300.219 367.863 300.278C367.634 300.567 367.395 300.871 367 301.158L367 303.929Z",
    fill: "url(#paint34_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 285.494L367.866 285.318C367.913 285.34 367.958 285.363 368 285.385L368 280.87C367.679 280.994 367.342 281.044 367 281.041L367 281.681C367.605 281.944 367.962 282.287 367.844 282.887C367.608 283.089 367.313 283.217 367 283.301L367 285.494Z",
    fill: "url(#paint35_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 279.882C367.348 279.978 367.694 280.06 368 280.123L368 279.183C367.668 279.221 367.322 279.237 367 279.222L367 279.882Z",
    fill: "url(#paint36_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 277.643L368 277.54L368 267.231C367.754 268.285 367.394 269.333 367 270.373L367 277.643Z",
    fill: "url(#paint37_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 258.75C367.31 258.791 367.642 258.83 368 258.867L368 246.822C367.99 246.832 367.98 246.842 367.97 246.852C367.654 247.166 367.308 247.51 367 247.874L367 251.257C367.067 251.309 367.138 251.36 367.214 251.411C367.15 251.406 367.078 251.401 367 251.395L367 258.75Z",
    fill: "url(#paint38_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 238.56C367.251 238.793 367.595 238.992 368 239.17L368 234.371C367.758 234.377 367.496 234.379 367.214 234.378L367.692 237.11L367 237.059L367 238.56Z",
    fill: "url(#paint39_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 225.526C367.348 225.769 367.667 226.082 368 226.421L368 225.325C367.653 225.409 367.326 225.451 367 225.462L367 225.526Z",
    fill: "url(#paint40_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 224.91C367.256 225.013 367.585 225.11 368 225.202L368 222.561C367.98 222.575 367.959 222.588 367.938 222.601C367.613 222.813 367.282 223.027 367 223.241L367 224.91Z",
    fill: "url(#paint41_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 220.625C367.344 220.603 367.679 220.603 368 220.637L368 213.162C367.655 213.235 367.32 213.307 367 213.378L367 215.025C367.456 215.138 367.802 215.312 367.953 215.582C367.653 215.622 367.332 215.643 367 215.654L367 220.625Z",
    fill: "url(#paint42_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 191.913C367.325 191.945 367.659 191.972 368 191.997L368 186.15C367.656 186.206 367.329 186.249 367 186.258L367 189.886C367.135 189.925 367.278 189.964 367.431 190.004C367.281 190.021 367.137 190.031 367 190.038L367 191.913Z",
    fill: "url(#paint43_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 161.307C367.402 161.414 367.719 161.578 368 161.777L368 161.002C367.742 161.063 367.414 161.122 367 161.177L367 161.307Z",
    fill: "url(#paint44_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 158.472C367.326 158.445 367.663 158.412 368 158.375L368 153.876C367.893 154.163 367.587 154.443 367 154.715L367 154.905C367.699 155.298 367.507 155.601 367 155.891L367 157.111C367.174 157.328 367.403 157.556 367.692 157.784L367 157.835L367 158.472Z",
    fill: "url(#paint45_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 152.169C367.473 152.576 367.87 152.977 368 153.368L368 147.14C367.449 147.739 366.995 148.366 367.083 148.996C367.055 148.993 367.027 148.989 367 148.985L367 152.169Z",
    fill: "url(#paint46_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 144.143L368 144.118L368 115.105C367.651 115.177 367.318 115.227 367 115.235L367 124.273C367.711 125.325 368.281 126.409 367 127.526L367 144.143Z",
    fill: "url(#paint47_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 110.778C367.305 110.7 367.625 110.64 367.953 110.603C367.969 110.606 367.984 110.609 368 110.612L368 107.779C367.582 107.886 367.259 107.991 367 108.095L367 110.778Z",
    fill: "url(#paint48_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 107.468C367.185 107.599 367.492 107.674 368 107.66L368 104.946C367.913 104.763 367.905 104.58 368 104.396L368 104.196C367.565 104.26 367.241 104.314 367 104.359L367 107.468Z",
    fill: "url(#paint49_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 97.7508L367.388 98.2733C367.779 97.8471 367.714 97.3127 367.409 96.3601C367.614 96.3859 367.811 96.4148 368 96.446L368 96.1401C367.903 96.1986 367.808 96.2684 367.714 96.352C367.241 95.9555 367.108 95.6079 367 95.2692L367 96.3154C367.132 96.3289 367.26 96.3439 367.388 96.3601C367.229 96.5177 367.105 96.5971 367 96.6252L367 97.7508Z",
    fill: "url(#paint50_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 59.2834L368 59.2784L368 18.1777C367.674 17.98 367.339 17.7966 367 17.6224L367 59.2834Z",
    fill: "url(#paint51_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 10.9749C367.336 10.9911 367.67 11.0177 368 11.0481L368 3.11741C367.652 2.97676 367.317 2.7864 367 2.5918L367 10.9749Z",
    fill: "url(#paint52_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368 99.0722L367.257 99.0251L368 99.2124L368 99.0722Z",
    fill: "url(#paint53_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368 100.568C367.79 100.602 367.586 100.636 367.388 100.671L367.461 100.673C367.642 100.678 367.821 100.683 368 100.693L368 100.568Z",
    fill: "url(#paint54_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368 168.348C367.871 168.315 367.74 168.28 367.605 168.243C367.743 168.303 367.875 168.362 368 168.419L368 168.348Z",
    fill: "url(#paint55_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368 183.464C367.798 183.666 367.573 183.864 367.322 184.056C367.567 184.034 367.793 184.016 368 184.001L368 183.464Z",
    fill: "url(#paint56_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368 185.384C367.96 185.449 367.956 185.511 368 185.567L368 185.384Z",
    fill: "url(#paint57_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368 240.867C367.284 241.874 367.206 242.455 368 243.088L368 240.867Z",
    fill: "url(#paint58_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368 289.596C367.861 290.372 367.906 291.175 367.947 291.899C368.012 293.063 368.065 294.018 367.322 294.306C367.571 294.417 367.796 294.528 368 294.639L368 289.596Z",
    fill: "url(#paint59_linear_22_257)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_22_257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.75 1L369 1L369 -1.60933e-05L338.16 -1.33971e-05L338.75 1Z",
    fill: "url(#paint60_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.504 -1.60933e-05L319.092 -1.44836e-05C319.68 0.457306 320.271 0.779875 320.864 1L326.756 1C328.538 0.69164 330.326 0.413726 332.106 1L337.445 1C337.447 0.95984 337.45 0.919534 337.453 0.879111C337.471 0.588396 337.49 0.291647 337.504 -1.60933e-05Z",
    fill: "url(#paint61_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.309 1C318.274 0.630483 318.263 0.277537 318.302 -1.60926e-05L315.399 -1.58389e-05L315.682 1L317.732 1C317.803 0.911029 317.883 0.901403 317.975 1L318.309 1Z",
    fill: "url(#paint62_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.805 1C314.812 0.67211 314.841 0.337014 314.904 -1.60933e-05L305.916 -1.53075e-05C305.913 0.326142 305.917 0.662371 305.942 1L314.805 1Z",
    fill: "url(#paint63_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.929 1C305.213 0.779694 305.455 0.480646 305.584 -1.60933e-05L301.105 -1.57017e-05C301.162 0.046151 301.22 0.0915878 301.278 0.137473C301.568 0.365636 301.871 0.604881 302.159 1L304.929 1Z",
    fill: "url(#paint64_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.494 1L286.318 0.134289C286.34 0.0870013 286.363 0.0422906 286.385 -1.60837e-05L281.87 -1.5689e-05C281.994 0.32053 282.044 0.658296 282.041 1L282.681 1C282.944 0.395001 283.287 0.0381948 283.887 0.156026C284.089 0.392134 284.217 0.686503 284.301 1L286.494 1Z",
    fill: "url(#paint65_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.882 1C280.977 0.652198 281.06 0.306387 281.123 -1.60933e-05L280.183 -1.60111e-05C280.221 0.331664 280.237 0.677686 280.222 1L280.882 1Z",
    fill: "url(#paint66_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.643 1L278.54 -1.60843e-05L268.231 -1.5183e-05C269.285 0.246116 270.333 0.606118 271.373 1L278.643 1Z",
    fill: "url(#paint67_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.75 1C259.792 0.690392 259.83 0.357502 259.867 -1.60933e-05L247.823 -1.50403e-05C247.832 0.00982612 247.842 0.0197003 247.852 0.0296044C248.166 0.345553 248.51 0.69234 248.874 1L252.257 1C252.309 0.933123 252.36 0.861967 252.411 0.786371C252.407 0.850485 252.402 0.922452 252.395 1L259.75 1Z",
    fill: "url(#paint68_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.56 1C239.793 0.748521 239.992 0.40465 240.169 -1.60933e-05L235.371 -1.56737e-05C235.377 0.242036 235.379 0.503763 235.378 0.786371L238.109 0.308177L238.059 1L239.56 1Z",
    fill: "url(#paint69_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.526 1C226.769 0.651524 227.082 0.332693 227.421 -1.60933e-05L226.325 -1.59974e-05C226.409 0.347172 226.451 0.674433 226.462 1L226.526 1Z",
    fill: "url(#paint70_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.91 1C226.013 0.744025 226.11 0.414654 226.202 -1.60933e-05L223.561 -1.58624e-05C223.575 0.0204675 223.588 0.0409858 223.601 0.0615231C223.813 0.387349 224.027 0.71832 224.241 1L225.91 1Z",
    fill: "url(#paint71_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.625 1C221.603 0.655907 221.604 0.321235 221.637 -1.60933e-05L214.162 -1.54398e-05C214.235 0.34484 214.307 0.680427 214.378 1L216.025 1C216.138 0.544454 216.312 0.197973 216.583 0.0473481C216.622 0.346871 216.643 0.667816 216.654 1L221.625 1Z",
    fill: "url(#paint72_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.914 1C192.945 0.675257 192.973 0.341258 192.998 -1.60933e-05L187.15 -1.5582e-05C187.207 0.344428 187.249 0.671282 187.259 1L190.886 1C190.925 0.865178 190.964 0.721672 191.004 0.56901C191.021 0.71922 191.032 0.862649 191.038 1L192.914 1Z",
    fill: "url(#paint73_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.307 1C162.414 0.597701 162.578 0.281336 162.777 -1.60933e-05L162.002 -1.60255e-05C162.063 0.257589 162.121 0.585783 162.177 1L162.307 1Z",
    fill: "url(#paint74_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.472 1C159.445 0.674155 159.412 0.33697 159.374 -1.60847e-05L154.876 -1.56915e-05C155.163 0.106792 155.443 0.412822 155.714 1L155.905 1C156.298 0.301181 156.601 0.492621 156.891 1L158.11 1C158.327 0.825574 158.555 0.596691 158.784 0.308177L158.835 1L159.472 1Z",
    fill: "url(#paint75_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.169 1C153.576 0.527217 153.977 0.129678 154.368 -1.60933e-05L148.14 -1.55487e-05C148.739 0.550609 149.366 1.00458 149.996 0.916786C149.993 0.945463 149.989 0.973196 149.985 1L153.169 1Z",
    fill: "url(#paint76_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.144 1L145.118 -1.6091e-05L116.105 -1.35547e-05C116.178 0.349151 116.228 0.681538 116.235 1L125.273 1C126.325 0.289371 127.409 -0.281199 128.526 1L145.144 1Z",
    fill: "url(#paint77_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.778 1C111.7 0.694814 111.64 0.375363 111.603 0.0473477C111.606 0.0314734 111.609 0.0156852 111.612 -1.60787e-05L108.778 -1.5831e-05C108.886 0.417636 108.991 0.741215 109.095 1L111.778 1Z",
    fill: "url(#paint78_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.468 1C108.599 0.815444 108.674 0.507856 108.66 -1.60931e-05L105.946 -1.58558e-05C105.763 0.0874036 105.58 0.0948477 105.397 -1.58078e-05L105.196 -1.57903e-05C105.261 0.435106 105.314 0.759128 105.359 1L108.468 1Z",
    fill: "url(#paint79_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7509 1L99.2734 0.612483C98.8473 0.221236 98.3128 0.286444 97.3602 0.590747C97.386 0.38585 97.4149 0.189311 97.4462 -1.59335e-05L97.1402 -1.59068e-05C97.1988 0.0967536 97.2685 0.192444 97.3521 0.286441C96.9556 0.759179 96.608 0.892027 96.2693 1L97.3155 1C97.329 0.868206 97.344 0.740345 97.3602 0.612483C97.5178 0.770506 97.5972 0.895435 97.6253 1L98.7509 1Z",
    fill: "url(#paint80_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2832 1L60.2782 -1.60928e-05L19.1774 -1.24997e-05C18.9797 0.32557 18.7963 0.661444 18.6221 1L60.2832 1Z",
    fill: "url(#paint81_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9746 1C11.9908 0.664153 12.0174 0.329894 12.0479 -1.60933e-05L4.11717 -1.53999e-05C3.97652 0.347872 3.78615 0.683451 3.59156 1L11.9746 1Z",
    fill: "url(#paint82_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.072 5.93794e-06L100.025 0.74292L100.212 5.92568e-06L100.072 5.93794e-06Z",
    fill: "url(#paint83_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.568 4.99971e-05C101.602 0.209804 101.636 0.41417 101.671 0.612549L101.673 0.538953C101.678 0.358132 101.683 0.179247 101.693 4.99861e-05L101.568 4.99971e-05Z",
    fill: "url(#paint84_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.348 3.24355e-06C169.316 0.128671 169.28 0.260308 169.243 0.395142C169.304 0.256928 169.362 0.125345 169.419 3.23739e-06L169.348 3.24355e-06Z",
    fill: "url(#paint85_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.464 3.05111e-05C184.666 0.202408 184.864 0.427384 185.056 0.677734C185.034 0.432915 185.016 0.207409 185.001 3.04642e-05L184.464 3.05111e-05Z",
    fill: "url(#paint86_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.384 1.21144e-06C186.449 0.0403019 186.511 0.0442859 186.567 1.19544e-06L186.384 1.21144e-06Z",
    fill: "url(#paint87_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.867 5.44933e-05C242.874 0.716248 243.456 0.794107 244.088 5.42991e-05L241.867 5.44933e-05Z",
    fill: "url(#paint88_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.596 3.09002e-05C291.372 0.138509 292.176 0.0935893 292.899 0.0531895C294.063 -0.0118596 295.018 -0.0652005 295.307 0.677734C295.417 0.429182 295.528 0.203913 295.639 3.04593e-05L290.596 3.09002e-05Z",
    fill: "url(#paint89_linear_22_257)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_22_257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.75 374L368 374L368 373L337.16 373L337.75 374Z",
    fill: "url(#paint90_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.504 373L318.092 373C318.68 373.457 319.271 373.78 319.864 374L325.756 374C327.538 373.692 329.326 373.414 331.106 374L336.445 374C336.447 373.96 336.45 373.92 336.453 373.879C336.471 373.588 336.49 373.292 336.504 373Z",
    fill: "url(#paint91_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.309 374C317.274 373.63 317.263 373.278 317.302 373L314.399 373L314.682 374L316.732 374C316.803 373.911 316.883 373.901 316.975 374L317.309 374Z",
    fill: "url(#paint92_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.805 374C313.812 373.672 313.841 373.337 313.904 373L304.916 373C304.913 373.326 304.917 373.662 304.942 374L313.805 374Z",
    fill: "url(#paint93_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.929 374C304.213 373.78 304.455 373.481 304.584 373L300.105 373C300.162 373.046 300.22 373.092 300.278 373.137C300.568 373.366 300.871 373.605 301.159 374L303.929 374Z",
    fill: "url(#paint94_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.494 374L285.318 373.134C285.34 373.087 285.363 373.042 285.385 373L280.87 373C280.994 373.321 281.044 373.658 281.041 374L281.681 374C281.944 373.395 282.287 373.038 282.887 373.156C283.089 373.392 283.217 373.687 283.301 374L285.494 374Z",
    fill: "url(#paint95_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.882 374C279.977 373.652 280.06 373.306 280.123 373L279.183 373C279.221 373.332 279.237 373.678 279.222 374L279.882 374Z",
    fill: "url(#paint96_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.643 374L277.54 373L267.231 373C268.285 373.246 269.333 373.606 270.373 374L277.643 374Z",
    fill: "url(#paint97_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.75 374C258.792 373.69 258.83 373.358 258.867 373L246.823 373C246.832 373.01 246.842 373.02 246.852 373.03C247.166 373.346 247.51 373.692 247.874 374L251.257 374C251.309 373.933 251.36 373.862 251.411 373.786C251.407 373.85 251.402 373.922 251.395 374L258.75 374Z",
    fill: "url(#paint98_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.56 374C238.793 373.749 238.992 373.405 239.169 373L234.371 373C234.377 373.242 234.379 373.504 234.378 373.786L237.109 373.308L237.059 374L238.56 374Z",
    fill: "url(#paint99_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.526 374C225.769 373.652 226.082 373.333 226.421 373L225.325 373C225.409 373.347 225.451 373.674 225.462 374L225.526 374Z",
    fill: "url(#paint100_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.91 374C225.013 373.744 225.11 373.415 225.202 373L222.561 373C222.575 373.02 222.588 373.041 222.601 373.062C222.813 373.387 223.027 373.718 223.241 374L224.91 374Z",
    fill: "url(#paint101_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.625 374C220.603 373.656 220.604 373.321 220.637 373L213.162 373C213.235 373.345 213.307 373.68 213.378 374L215.025 374C215.138 373.544 215.312 373.198 215.583 373.047C215.622 373.347 215.643 373.668 215.654 374L220.625 374Z",
    fill: "url(#paint102_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.914 374C191.945 373.675 191.973 373.341 191.998 373L186.15 373C186.207 373.344 186.249 373.671 186.259 374L189.886 374C189.925 373.865 189.964 373.722 190.004 373.569C190.021 373.719 190.032 373.863 190.038 374L191.914 374Z",
    fill: "url(#paint103_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.307 374C161.414 373.598 161.578 373.281 161.777 373L161.002 373C161.063 373.258 161.121 373.586 161.177 374L161.307 374Z",
    fill: "url(#paint104_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.472 374C158.445 373.674 158.412 373.337 158.374 373L153.876 373C154.163 373.107 154.443 373.413 154.714 374L154.905 374C155.298 373.301 155.601 373.493 155.891 374L157.11 374C157.327 373.826 157.555 373.597 157.784 373.308L157.835 374L158.472 374Z",
    fill: "url(#paint105_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.169 374C152.576 373.527 152.977 373.13 153.368 373L147.14 373C147.739 373.551 148.366 374.005 148.996 373.917C148.993 373.945 148.989 373.973 148.985 374L152.169 374Z",
    fill: "url(#paint106_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.144 374L144.118 373L115.105 373C115.178 373.349 115.228 373.682 115.235 374L124.273 374C125.325 373.289 126.409 372.719 127.526 374L144.144 374Z",
    fill: "url(#paint107_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.778 374C110.7 373.695 110.64 373.375 110.603 373.047C110.606 373.031 110.609 373.016 110.612 373L107.778 373C107.886 373.418 107.991 373.741 108.095 374L110.778 374Z",
    fill: "url(#paint108_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.468 374C107.599 373.815 107.674 373.508 107.66 373L104.946 373C104.763 373.087 104.58 373.095 104.397 373L104.196 373C104.261 373.435 104.314 373.759 104.359 374L107.468 374Z",
    fill: "url(#paint109_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7509 374L98.2734 373.612C97.8473 373.221 97.3128 373.286 96.3602 373.591C96.386 373.386 96.4149 373.189 96.4462 373L96.1402 373C96.1988 373.097 96.2685 373.192 96.3521 373.286C95.9556 373.759 95.608 373.892 95.2693 374L96.3155 374C96.329 373.868 96.344 373.74 96.3602 373.612C96.5178 373.771 96.5972 373.895 96.6253 374L97.7509 374Z",
    fill: "url(#paint110_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2832 374L59.2782 373L18.1774 373C17.9797 373.326 17.7963 373.661 17.6221 374L59.2832 374Z",
    fill: "url(#paint111_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9746 374C10.9908 373.664 11.0174 373.33 11.0479 373L3.11717 373C2.97652 373.348 2.78615 373.683 2.59156 374L10.9746 374Z",
    fill: "url(#paint112_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0722 373L99.0251 373.743L99.2124 373L99.0722 373Z",
    fill: "url(#paint113_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.568 373C100.602 373.21 100.636 373.414 100.671 373.613L100.673 373.539C100.678 373.358 100.683 373.179 100.693 373L100.568 373Z",
    fill: "url(#paint114_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.348 373C168.316 373.129 168.28 373.26 168.243 373.395C168.304 373.257 168.362 373.125 168.419 373L168.348 373Z",
    fill: "url(#paint115_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.464 373C183.666 373.202 183.864 373.427 184.056 373.678C184.034 373.433 184.016 373.207 184.001 373L183.464 373Z",
    fill: "url(#paint116_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.384 373C185.449 373.04 185.511 373.044 185.567 373L185.384 373Z",
    fill: "url(#paint117_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.867 373C241.874 373.716 242.456 373.794 243.088 373L240.867 373Z",
    fill: "url(#paint118_linear_22_257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.596 373C290.372 373.139 291.176 373.094 291.899 373.053C293.063 372.988 294.018 372.935 294.307 373.678C294.417 373.429 294.528 373.204 294.639 373L289.596 373Z",
    fill: "url(#paint119_linear_22_257)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22_257",
    x1: 0.0685558,
    y1: 369.327,
    x2: 1.53465,
    y2: 369.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22_257",
    x1: 0.0685558,
    y1: 337.296,
    x2: 1.53344,
    y2: 337.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_22_257",
    x1: 0.0685558,
    y1: 317.434,
    x2: 1.46398,
    y2: 317.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_22_257",
    x1: 0.0685558,
    y1: 314.291,
    x2: 1.5275,
    y2: 314.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_22_257",
    x1: 0.0685558,
    y1: 304.776,
    x2: 1.50433,
    y2: 304.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_22_257",
    x1: 0.0685558,
    y1: 285.693,
    x2: 1.50621,
    y2: 285.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_22_257",
    x1: 0.0685558,
    y1: 280.164,
    x2: 1.05296,
    y2: 279.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_22_257",
    x1: 0.0685558,
    y1: 278.091,
    x2: 1.52948,
    y2: 277.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_22_257",
    x1: 0.0685558,
    y1: 259.385,
    x2: 1.53095,
    y2: 259.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_22_257",
    x1: 0.0685558,
    y1: 239.376,
    x2: 1.50825,
    y2: 239.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_22_257",
    x1: 0.0685558,
    y1: 226.469,
    x2: 1.14696,
    y2: 225.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_22_257",
    x1: 0.0685558,
    y1: 225.316,
    x2: 1.4496,
    y2: 224.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_22_257",
    x1: 0.0685558,
    y1: 220.958,
    x2: 1.52404,
    y2: 220.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_22_257",
    x1: 0.0685558,
    y1: 192.249,
    x2: 1.51698,
    y2: 192.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_22_257",
    x1: 0.0685558,
    y1: 161.811,
    x2: 0.921312,
    y2: 161.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_22_257",
    x1: 0.0685558,
    y1: 158.67,
    x2: 1.50586,
    y2: 158.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_22_257",
    x1: 0.0685558,
    y1: 153.636,
    x2: 1.51913,
    y2: 153.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_22_257",
    x1: 0.0685558,
    y1: 145.393,
    x2: 1.53456,
    y2: 145.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_22_257",
    x1: 0.0685558,
    y1: 110.907,
    x2: 1.46801,
    y2: 110.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_22_257",
    x1: 0.0685558,
    y1: 107.811,
    x2: 1.4843,
    y2: 107.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_22_257",
    x1: 0.0685558,
    y1: 98.4026,
    x2: 1.46819,
    y2: 98.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_22_257",
    x1: 0.0685559,
    y1: 61.0757,
    x2: 1.53495,
    y2: 61.0525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_22_257",
    x1: 0.0685558,
    y1: 11.4119,
    x2: 1.52649,
    y2: 11.2985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_22_257",
    x1: 0.308254,
    y1: 99.2205,
    x2: 0.447741,
    y2: 98.8564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_22_257",
    x1: 0.429685,
    y1: 100.698,
    x2: 0.508826,
    y2: 100.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_22_257",
    x1: 0.632069,
    y1: 168.426,
    x2: 0.814394,
    y2: 168.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_22_257",
    x1: 0.368725,
    y1: 184.081,
    x2: 1.0029,
    y2: 183.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_22_257",
    x1: 0.970437,
    y1: 185.575,
    x2: 1.01639,
    y2: 185.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_22_257",
    x1: 0.471957,
    y1: 243.183,
    x2: 1.2804,
    y2: 243.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_22_257",
    x1: 0.368725,
    y1: 294.855,
    x2: 1.35503,
    y2: 294.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_22_257",
    x1: 367.069,
    y1: 369.327,
    x2: 368.535,
    y2: 369.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_22_257",
    x1: 367.069,
    y1: 337.296,
    x2: 368.533,
    y2: 337.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_22_257",
    x1: 367.069,
    y1: 317.434,
    x2: 368.464,
    y2: 317.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_22_257",
    x1: 367.069,
    y1: 314.291,
    x2: 368.527,
    y2: 314.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_22_257",
    x1: 367.069,
    y1: 304.776,
    x2: 368.504,
    y2: 304.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_22_257",
    x1: 367.069,
    y1: 285.693,
    x2: 368.506,
    y2: 285.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_22_257",
    x1: 367.069,
    y1: 280.164,
    x2: 368.053,
    y2: 279.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_22_257",
    x1: 367.069,
    y1: 278.091,
    x2: 368.529,
    y2: 277.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_22_257",
    x1: 367.069,
    y1: 259.385,
    x2: 368.531,
    y2: 259.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_22_257",
    x1: 367.069,
    y1: 239.376,
    x2: 368.508,
    y2: 239.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_22_257",
    x1: 367.069,
    y1: 226.469,
    x2: 368.147,
    y2: 225.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_22_257",
    x1: 367.069,
    y1: 225.316,
    x2: 368.45,
    y2: 224.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_22_257",
    x1: 367.069,
    y1: 220.958,
    x2: 368.524,
    y2: 220.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_22_257",
    x1: 367.069,
    y1: 192.249,
    x2: 368.517,
    y2: 192.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_22_257",
    x1: 367.069,
    y1: 161.811,
    x2: 367.921,
    y2: 161.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_22_257",
    x1: 367.069,
    y1: 158.67,
    x2: 368.506,
    y2: 158.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_22_257",
    x1: 367.069,
    y1: 153.636,
    x2: 368.519,
    y2: 153.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_22_257",
    x1: 367.069,
    y1: 145.393,
    x2: 368.535,
    y2: 145.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_22_257",
    x1: 367.069,
    y1: 110.907,
    x2: 368.468,
    y2: 110.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_22_257",
    x1: 367.069,
    y1: 107.811,
    x2: 368.484,
    y2: 107.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_22_257",
    x1: 367.069,
    y1: 98.4026,
    x2: 368.468,
    y2: 98.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_22_257",
    x1: 367.069,
    y1: 61.0757,
    x2: 368.535,
    y2: 61.0525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_22_257",
    x1: 367.069,
    y1: 11.4119,
    x2: 368.526,
    y2: 11.2985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_22_257",
    x1: 367.308,
    y1: 99.2205,
    x2: 367.448,
    y2: 98.8564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_22_257",
    x1: 367.43,
    y1: 100.698,
    x2: 367.509,
    y2: 100.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_22_257",
    x1: 367.632,
    y1: 168.426,
    x2: 367.814,
    y2: 168.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_22_257",
    x1: 367.369,
    y1: 184.081,
    x2: 368.003,
    y2: 183.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_22_257",
    x1: 367.97,
    y1: 185.575,
    x2: 368.016,
    y2: 185.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_22_257",
    x1: 367.472,
    y1: 243.183,
    x2: 368.28,
    y2: 243.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_22_257",
    x1: 367.369,
    y1: 294.855,
    x2: 368.355,
    y2: 294.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_22_257",
    x1: 370.327,
    y1: 0.931444,
    x2: 370.295,
    y2: -0.534646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_22_257",
    x1: 338.296,
    y1: 0.931444,
    x2: 338.244,
    y2: -0.533443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_22_257",
    x1: 318.434,
    y1: 0.931444,
    x2: 318.119,
    y2: -0.463978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_22_257",
    x1: 315.291,
    y1: 0.931444,
    x2: 315.184,
    y2: -0.527499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_22_257",
    x1: 305.777,
    y1: 0.931444,
    x2: 305.566,
    y2: -0.504335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_22_257",
    x1: 286.693,
    y1: 0.931444,
    x2: 286.488,
    y2: -0.506212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_22_257",
    x1: 281.163,
    y1: 0.931444,
    x2: 280.474,
    y2: -0.0529622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_22_257",
    x1: 279.091,
    y1: 0.931444,
    x2: 278.999,
    y2: -0.529481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_22_257",
    x1: 260.385,
    y1: 0.931444,
    x2: 260.305,
    y2: -0.53095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_22_257",
    x1: 240.376,
    y1: 0.931444,
    x2: 240.178,
    y2: -0.508253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_22_257",
    x1: 227.469,
    y1: 0.931444,
    x2: 226.821,
    y2: -0.14696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_22_257",
    x1: 226.316,
    y1: 0.931444,
    x2: 225.972,
    y2: -0.449598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_22_257",
    x1: 221.958,
    y1: 0.931444,
    x2: 221.83,
    y2: -0.524037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_22_257",
    x1: 193.249,
    y1: 0.931444,
    x2: 193.086,
    y2: -0.516979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_22_257",
    x1: 162.811,
    y1: 0.931444,
    x2: 162.087,
    y2: 0.078688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_22_257",
    x1: 159.67,
    y1: 0.931444,
    x2: 159.464,
    y2: -0.505862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_22_257",
    x1: 154.636,
    y1: 0.931444,
    x2: 154.483,
    y2: -0.51913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_22_257",
    x1: 146.393,
    y1: 0.931444,
    x2: 146.36,
    y2: -0.534561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_22_257",
    x1: 111.907,
    y1: 0.931444,
    x2: 111.6,
    y2: -0.468007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_22_257",
    x1: 108.811,
    y1: 0.931444,
    x2: 108.542,
    y2: -0.484302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_22_257",
    x1: 99.4027,
    y1: 0.931444,
    x2: 99.0962,
    y2: -0.468189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_22_257",
    x1: 62.0754,
    y1: 0.931444,
    x2: 62.0523,
    y2: -0.534948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_22_257",
    x1: 12.4116,
    y1: 0.931444,
    x2: 12.2982,
    y2: -0.526489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_22_257",
    x1: 100.22,
    y1: 0.69199,
    x2: 99.8564,
    y2: 0.552503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_22_257",
    x1: 101.698,
    y1: 0.570559,
    x2: 101.444,
    y2: 0.491419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_22_257",
    x1: 169.427,
    y1: 0.368053,
    x2: 169.157,
    y2: 0.185728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_22_257",
    x1: 185.081,
    y1: 0.631275,
    x2: 184.603,
    y2: -0.0028953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_22_257",
    x1: 186.575,
    y1: 0.0295626,
    x2: 186.57,
    y2: -0.0163894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_22_257",
    x1: 244.183,
    y1: 0.527921,
    x2: 244.048,
    y2: -0.280524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_22_257",
    x1: 295.856,
    y1: 0.631275,
    x2: 295.768,
    y2: -0.355026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_22_257",
    x1: 369.327,
    y1: 373.931,
    x2: 369.295,
    y2: 372.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_22_257",
    x1: 337.296,
    y1: 373.931,
    x2: 337.244,
    y2: 372.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_22_257",
    x1: 317.434,
    y1: 373.931,
    x2: 317.119,
    y2: 372.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_22_257",
    x1: 314.291,
    y1: 373.931,
    x2: 314.184,
    y2: 372.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_22_257",
    x1: 304.777,
    y1: 373.931,
    x2: 304.566,
    y2: 372.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_22_257",
    x1: 285.693,
    y1: 373.931,
    x2: 285.488,
    y2: 372.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_22_257",
    x1: 280.163,
    y1: 373.931,
    x2: 279.474,
    y2: 372.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_22_257",
    x1: 278.091,
    y1: 373.931,
    x2: 277.999,
    y2: 372.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_22_257",
    x1: 259.385,
    y1: 373.931,
    x2: 259.305,
    y2: 372.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_22_257",
    x1: 239.376,
    y1: 373.931,
    x2: 239.178,
    y2: 372.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_22_257",
    x1: 226.469,
    y1: 373.931,
    x2: 225.821,
    y2: 372.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_22_257",
    x1: 225.316,
    y1: 373.931,
    x2: 224.972,
    y2: 372.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_22_257",
    x1: 220.958,
    y1: 373.931,
    x2: 220.83,
    y2: 372.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_22_257",
    x1: 192.249,
    y1: 373.931,
    x2: 192.086,
    y2: 372.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_22_257",
    x1: 161.811,
    y1: 373.931,
    x2: 161.087,
    y2: 373.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_22_257",
    x1: 158.67,
    y1: 373.931,
    x2: 158.464,
    y2: 372.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_22_257",
    x1: 153.636,
    y1: 373.931,
    x2: 153.483,
    y2: 372.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_22_257",
    x1: 145.393,
    y1: 373.931,
    x2: 145.36,
    y2: 372.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_22_257",
    x1: 110.907,
    y1: 373.931,
    x2: 110.6,
    y2: 372.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_22_257",
    x1: 107.811,
    y1: 373.931,
    x2: 107.542,
    y2: 372.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_22_257",
    x1: 98.4027,
    y1: 373.931,
    x2: 98.0962,
    y2: 372.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_22_257",
    x1: 61.0754,
    y1: 373.931,
    x2: 61.0523,
    y2: 372.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_22_257",
    x1: 11.4116,
    y1: 373.931,
    x2: 11.2982,
    y2: 372.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_22_257",
    x1: 99.2205,
    y1: 373.692,
    x2: 98.8564,
    y2: 373.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_22_257",
    x1: 100.698,
    y1: 373.571,
    x2: 100.444,
    y2: 373.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_22_257",
    x1: 168.427,
    y1: 373.368,
    x2: 168.157,
    y2: 373.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_22_257",
    x1: 184.081,
    y1: 373.631,
    x2: 183.603,
    y2: 372.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_22_257",
    x1: 185.575,
    y1: 373.03,
    x2: 185.57,
    y2: 372.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_22_257",
    x1: 243.183,
    y1: 373.528,
    x2: 243.048,
    y2: 372.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_22_257",
    x1: 294.856,
    y1: 373.631,
    x2: 294.768,
    y2: 372.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 368,
    height: 1.00002,
    fill: "white",
    transform: "translate(0 368) rotate(-90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_22_257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 368,
    height: 1.00002,
    fill: "white",
    transform: "translate(367 368) rotate(-90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_22_257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 368,
    height: 1.00002,
    fill: "white",
    transform: "translate(369 1) rotate(180)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_22_257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 368,
    height: 1.00002,
    fill: "white",
    transform: "translate(368 374) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDividerPrimaryGradient);
export default __webpack_public_path__ + "static/media/divider-primary-gradient.620c88dc76a0f9640b6a4e927168dd1f.svg";
export { ForwardRef as ReactComponent };